import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/webCam'

export const webCamService = {
    getList,
    getItem,
    saveItem,
    updateItem,
    deleteItem,
    getAll,
    getPagedList,
    search
};

//index
function getList() {
    return utilHelper.doRequest(`${relativeUrl}`, 'GET')
}

//getAll
function getAll() {
    return utilHelper.doRequest(`${relativeUrl}/getAll`, 'GET')
}

//search
function getPagedList(offset, max) {
    return utilHelper.doRequest(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'GET')
}

//show
function getItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'GET')
}




//search
function search(offset, max, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data: data, showAlert: false })
}

//save
function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', {data:data});
}

//update
function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', {data:data});
}

//delete
function deleteItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'DELETE',{})
}